export const traHang = {
  sections: {
    list: { title: 'Returns' },
    detail: { title: 'Return voucher detail' },
    traHang: 'Return',
    muaHang: 'Purchase',
  },
  titles: { add: 'Create return' },
  columns: {
    code: 'Code',
    summary: 'Summary',
    status: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
  },
  filter: { searchPlaceholder: 'Search by return code...' },
  filters: {
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    all: 'All',
    fromDate: 'From date',
    toDate: 'To date',
    dateRange: 'Date range',
    dateRangePlaceholder: 'Select date range',
    status: 'Status',
    statusSection: 'Voucher status',
    dateSection: 'Return date',
    salesSection: 'Sales',
    peopleSection: 'Users',
    seller: 'Seller',
    receiverReturn: 'Return receiver',
    deliverySection: 'Delivery',
    deliveryPartner: 'Delivery partner',
    deliveryArea: 'Delivery area',
    deliveryStatus: 'Delivery status',
    otherIncomeType: 'Other income type',
    returnType: 'Return type',
    textDetailTitle: 'Return filter',
    khachHangPlaceholder: 'Search customer',
    hintSection: 'Tips',
    hintBody: 'Use the search box to filter quickly.',
    sortField: 'Sort by',
    sortDir: 'Order',
    sortThoiGian: 'Time',
    sortMaPhieu: 'Return code',
    sortCanTraKhach: 'Refund due',
    sortTongTienHang: 'Merchandise total',
  },
  form: {
    code: 'Return code',
    codeAuto: 'Leave empty to auto-generate',
    customer: 'Customer',
    retailCustomer: 'Walk-in customer',
    customerQuickAdd: 'Quick add customer',
    channel: 'Sales channel',
    returnFee: 'Return fee',
    note: 'Note',
    lines: 'Returned items',
    danhSachChiTiet: 'Detail list',
    addLine: 'Add line',
    product: 'Product',
    productName: 'Product name',
    productSearch: 'Search code / name',
    qty: 'Quantity',
    qtyTra: 'Return qty',
    canTruCongNoHint: 'Invoice is unpaid: {soTien} is offset against receivables, not refunded in cash.',
    unitPrice: 'Unit price',
    discount: 'Discount',
    discountPercent: 'Discount (%)',
    lineNote: 'Line note',
    quickSearch: 'Search return item (F3)',
    quickSearchDoi: 'Search exchange item (F7)',
    time: 'Time',
    customerInfo: 'Return information',
    sourceInvoice: 'Source invoice',
    sourceInvoiceSearch: 'Find invoice to return',
    sourceInvoiceEmpty: 'No invoice selected',
    sourceInvoiceClear: 'Clear invoice',
    returnInfo: 'Return details',
    paymentMethod: 'Refund method',
    orderNote: 'Order note',
    refundAmount: 'Amount to customer',
    discountType: 'Discount type',
    discountValue: 'Discount value',
    openSourceInvoice: 'Pick from invoice',
    byAmount: 'By amount',
    byPercent: 'By percent',
    donViTinh: 'Unit',
    giaBan: 'Sale price',
    thanhTien: 'Line total',
    bangGia: 'Price table',
    bangGiaDefault: 'Default price',
    creator: 'Creator',
    seller: 'Seller',
    tabLines: 'Item details',
    maHang: 'Item code',
    discountShort: 'Discount',
    salePrice: 'Sale price',
    lineAmount: 'Amount',
  },
  messages: {
    loadError: 'Could not load returns.',
    deleteSuccess: 'Deleted.',
    createSuccess: 'Return voucher created.',
    updateSuccess: 'Return voucher updated.',
    needLines: 'Please add at least one line.',
    noData: 'No returns.',
    noLines: 'No lines.',
    listSummary: 'Total {count}',
    confirmDelete: 'Delete voucher {name}?',
    cancelSuccess: 'Return voucher cancelled.',
    confirmHuy: 'Cancel return voucher {name}? Status will be set to Cancelled.',
    refundSuccess: 'Refund recorded.',
    invalidPayAmount: 'Invalid refund amount.',
    refundInlineSuccess: 'Return voucher created + refund recorded.',
    sourceInvoiceLoaded: 'Loaded {count} lines from invoice {code}.',
    sourceInvoiceNotFound: 'Invoice not found.',
    sourceInvoiceDaTraHet: 'This invoice is fully returned — no remaining quantity to return.',
    error: 'An error occurred.',
    phieuXuatKhoFromReturn: 'Sales out from return {code}',
  },
  actions: {
    refund: 'Refund',
    cancelVoucher: 'Cancel voucher',
    pay: 'Return',
    clear: 'Clear',
    detail: 'Detail',
    ketThuc: 'Complete',
    xuLyDonHang: 'Process order',
    print: 'Print',
    exportFile: 'Export file',
    copy: 'Copy',
    saoChep: 'Copy',
    taoPhieuXuatKho: 'Create stock-out voucher',
    capNhat: 'Update',
    dongY: 'Agree',
    huyBo: 'Cancel',
  },
  fields: {
    totalAmount: 'Total amount',
    refundedAmount: 'Refunded',
    refundAmount: 'Refund amount',
    paymentMethod: 'Payment method',
    tongTienHangGoc: 'Original goods total',
    tongTienHangTra: 'Returned goods total',
    giamGia: 'Discount',
    phiTraHang: 'Return fee',
    hoanTraThuKhac: 'Other refund',
    tongTienTra: 'Total refund',
    tongTienHang: 'Goods total',
    tongTienMua: 'Purchase total',
    thuKhac: 'Other charges',
    giaoHang: 'Delivery',
    canTraKhach: 'Amount due to customer',
    khachCanTra: 'Customer must pay',
    khachNhanLai: 'Paid to customer',
    maHoaDonNguon: 'From invoice',
    maPhieuNhapKho: 'Stock-in voucher',
    maPhieuXuatKho: 'Stock-out voucher',
    tenKhachHang: 'Customer',
    khachHang: 'Customer',
    maPhieuTraHang: 'Return code',
    thoiGian: 'Return datetime',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    ngayDatHang: 'Return datetime',
    nguoiTao: 'Created by',
    nguoiBan: 'Seller',
    nguoiNhanTra: 'Return receiver',
    kenhBan: 'Sales channel',
    trangThai: 'Status',
    chiNhanh: 'Branch',
    loaiTraHang: 'Return type',
    ghiChu: 'Note',
    yeuThich: 'Favorite',
    actions: 'Actions',
    maDatHang: 'Order code',
    maHoaDon: 'Invoice code',
    nguoiNhanDat: 'Order taker',
    bangGia: 'Price list',
    giamGiaHoaDon: 'Invoice discount',
    phiShip: 'Shipping fee',
    chiNhanhXuLy: 'Handling branch',
    chiNhanhTao: 'Created at branch',
    diaChiLayHang: 'Pickup address',
    nguoiNhan: 'Receiver',
    dienThoai: 'Phone',
    diaChi: 'Address',
    khuVuc: 'Area',
    phuongXa: 'Ward',
    ghiChuGiaoHang: 'Delivery note',
    maVanDon: 'Tracking code',
    trongLuong: 'Weight',
    kichThuoc: 'Dimensions',
    dichVu: 'Service',
    nguoiGiaoDoiTac: 'Courier',
    thuHoTienShort: 'COD',
    phiTraDTGH: 'Fee paid to carrier',
    thoiGianGiaoHang: 'Delivery deadline',
    khachDaTra: 'Customer paid',
  },
  aria: {
    columnPicker: 'Choose columns',
  },
  detailTabs: {
    chung: 'General',
    generalInfo: 'Information',
    chiTietDonHang: 'Order details',
  },
  status: {
    MOI_TAO: 'New',
    HOAN_THANH: 'Completed',
    DA_HUY: 'Cancelled',
  },
  loaiTraHang: {
    THEO_HOA_DON: 'By invoice',
    TRA_NHANH: 'Quick return',
    CHUYEN_HOAN: 'Transfer-return',
  },
  paymentMethod: {
    TIEN_MAT: 'Cash',
    THE: 'Card',
    VI: 'Wallet',
    CHUYEN_KHOAN: 'Transfer',
  },
  pos: {
    addTab: 'Add return tab',
    tabTitle: 'Return {n}',
    tabEdit: 'Edit {code}',
    tabClone: 'Clone {code}',
    tabFromInvoice: 'From inv {code}',
    history: 'Return history',
    confirmCloseTitle: 'Close tab?',
    confirmCloseBody: 'Unsaved data will be lost. Continue?',
    openEdit: 'Edit this voucher',
    openClone: 'Make a clone',
    openFromInvoice: 'Return this invoice',
    newTabHoaDon: 'New invoice',
    newTabTraHang: 'New return',
    filterAll: 'All',
    filterHoaDon: 'Invoice',
    filterTraHang: 'Return',
    viewFullList: 'View full list',
  },
  placeholders: {
    formTitle: 'Create / edit return',
    formBody: 'Full form will be added later.',
    ghiChu: 'Note...',
    ghiChuGiao: 'Delivery note...',
    chonDoiTac: 'Select partner...',
  },
  sourceInvoicePicker: {
    title: 'Select invoice to return',
    searchSection: 'Search',
    maHoaDon: 'By invoice code',
    maKhachHang: 'By customer code',
    tenKhachHang: 'By customer name',
    maHang: 'By product code',
    tenHang: 'By product name',
    timeSection: 'Time',
    timeAll: 'All time',
    fromDate: 'From',
    toDate: 'To',
    sellerSection: 'Seller',
    sellerPlaceholder: 'Select seller',
    statusSection: 'Invoice status',
    hint: 'Only non-cancelled invoices of the current branch are shown.',
    choose: 'Select',
    noData: 'No matching invoices found.',
    summary: '{count} invoices',
    columns: {
      maHoaDon: 'Invoice code',
      thoiGian: 'Time',
      khachHang: 'Customer',
      nguoiBan: 'Seller',
      trangThai: 'Status',
      tongTienHang: 'Subtotal',
      khachCanTra: 'Customer payable',
      khachDaTra: 'Customer paid',
    },
  },
  summary: {
    tongTienHangCount: 'Subtotal ({count})',
    tongSoLuong: 'Total quantity',
    tongTienHang: 'Subtotal',
    giamGiaPhieuDat: 'Discount',
    tongCong: 'Total',
    hangSuaChua: 'Repair items',
  },
}
